import { IProductDataV2, Product } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { ProcessorService } from '@df/ng/processor.service';
import flatten from 'lodash-es/flatten';
import union from 'lodash-es/union';

export function normalizeProducts(originalIds: number[], productIds: number[], prioritizeParent = false): number[] {
    const app = ProcessorService.injector.get(App);

    // initialise parents by taking paretsn of original products (we will push new parents and ids later)
    // We take family twice cause children may belong to another parents.
    const disallowedProducts = flatten(
        app.resources.product
            .getAllExisting(
                union(flatten<number>(app.resources.product.getAllExisting(originalIds).map(model => model.family.map(i => i.id)))).filter(
                    i => !!i
                )
            )
            .map(i => i.family.map(f => f.id))
    );
    const ids = <number[]>app.resources.product
        .toModels(productIds, true)
        .map(model => {
            if (!model.isOutOfStock) {
                const parent = (<IProductDataV2>model.data).parent;
                const id = model.id;
                // it is possible that we will try to print more then one product from
                // the family, so before we do anything we will first filter for that
                // note that divergent product may be presented next to each other even when having same parent
                if (parent) {
                    if (!(<IProductDataV2>model.data).isDivergent) {
                        if (disallowedProducts.includes(parent)) {
                            return false;
                        } else {
                            // if non divergant and parent not yet processed in disallowed, add its parent
                            disallowedProducts.push(parent);
                        }
                    }
                }
                // check it directly too
                if (id) {
                    if (disallowedProducts.includes(id)) {
                        return false;
                    } else {
                        // add model to disallowed (prevent duplcates)
                        disallowedProducts.push(id);
                    }
                }

                return id;
            }
            return undefined;
        })
        .filter(item => !!item);
    if (prioritizeParent) {
        return ids.map(productId => {
            const product = app.resources.product.getExisting(productId) as Product<IProductDataV2>;
            const parent = product?.data?.parent;
            if (parent && productIds.indexOf(parent) > -1) {
                return parent;
            }
            return productId;
        });
    }
    return ids;
}
